import React from 'react';
import './about.css';

// ================= DATA OBJECT =================

const aboutUsData = {
  title: "गट ग्रामपंचायत वेती /वरोती: प्रगतीचा संकल्प",

  intro:
    "वेती /वरोती डहाणू तालुक्यात असलेले, संस्कृती आणि कृषीचे उत्तम मिश्रण असलेले गाव आहे. स्थानिक स्वराज्य संस्था म्हणून आम्ही, वेती /वरोती एक आदर्श, आत्मनिर्भर आणि तंत्रज्ञान-स्नेही गाव बनवण्यासाठी कटिबद्ध आहोत.",

  // ================= VISION =================

  visionTitle: "💡 आमची दृष्टी (Our Vision)",

  vision: [
    {
      icon: "🌐",
      title: "डिजिटल ग्राम",
      description:
        "ग्रामपंचायतीचे कामकाज पारदर्शक आणि डिजिटल माध्यमांतून चालवणे.",
    },
    {
      icon: "🌿",
      title: "पर्यावरण पूरक विकास",
      description:
        "गावातील स्वच्छता, पाणी व्यवस्थापन आणि नैसर्गिक संसाधनांचे संरक्षण करणे.",
    },
    {
      icon: "🤝",
      title: "युवा आणि महिला सबलीकरण",
      description:
        "शिक्षण, आरोग्य आणि रोजगाराच्या संधी उपलब्ध करून तरुण आणि महिलांना सशक्त करणे.",
    },
  ],

  // ================= SERVICES =================

  servicesTitle: "🏗 सेवा आणि सुविधा",

  services: [
    "पायाभूत सुविधा: उत्तम रस्ते, पाणीपुरवठा आणि सार्वजनिक बांधकाम.",
    "दाखले आणि नोंदी: जन्म-मृत्यू, रहिवासी दाखले वेळेत देणे.",
    "शासकीय योजना: शासनाच्या योजनांचा लाभ नागरिकांपर्यंत पोहोचवणे.",
  ],

  // ================= GRAM PANCHAYAT INFO =================

  gramPanchayatInfo: {
    title: "📄 ग्रामपंचायतीची माहिती",
    details: [
      "ग्रामपंचायतीचे नाव : वेती /वरोती",
      "तालुका : डहाणू",
      "जिल्हा : पालघर",
      "स्थापना वर्ष : 1962",
      "नोंदणी क्रमांक : --",
      "मतदार संख्या : --",
      "सदस्य संख्या : 12",
      "सरपंच : श्रीम. मनीषा भरत  डोकफोडे",
      "उपसरपंच : श्री  सुरेश देव्या दांडेकर",
      "ग्रामसेवक : श्री सुदेश लहानु कोद्या",
      "कार्यालय संपर्क : 9545174890"
    ]
  },

  // ================= POPULATION =================

  population2011: {
    title: "📊 लोकसंख्या सन २०११ ची जनगणना",

    villages: [
      {
        name: "वेती",
        kutumb: 520,
        female: 1446,
        male: 1350,
        total: 2796,
      },
      {
        name: "वरोती",
        kutumb: 270,
        female: 669,
        male: 696,
        total: 1365,
      },
      {
        name: "सूर्यनगर",
        kutumb: 112,
        female: 350,
        male: 436,
        total: 786,
      },
    ],

    total: {
      kutumb: 902,
      female: 2465,
      male: 2482,
      total: 4947,
    },
  },

  // ================= EDUCATION =================

  education: {
    title: "📚 शिक्षण व्यवस्था",

    email: "--@gmail.com",

    content: [
      "जिल्हा परिषद शाळा कार्यरत आहे.",
      "इयत्ता १ ली ते ७ वी पर्यंत शिक्षण उपलब्ध आहे.",
      "मोफत पुस्तके, गणवेश व शिष्यवृत्ती दिली जाते.",
      "शाळेत पिण्याचे पाणी व स्वच्छतागृह सुविधा आहे.",
    ],
  },

  // ================= PARTICIPATION =================

  participation: {
    heading: "🤝 तुमचा सहभाग महत्त्वाचा",

    content:
      "ग्रामपंचायत ही गावकऱ्यांची संस्था आहे. ग्रामसभेत सहभाग महत्त्वाचा आहे.",
  },

  // ================= SARPANCH =================

  sarpanch: {
    name: "श्रीम. मनीषा भरत  डोकफोडे",

    slogan: "👉 प्रत्येक नागरिकाच्या आवाजाला महत्त्व",

    closing:
      "वेती /वरोती नागरिकांचे प्रेम आणि विश्वास हीच आमची प्रेरणा आहे.",
  },
};

// ================= COMPONENT =================

const VisionItem = ({ icon, title, description }) => (

  <div className="vision-card">

    <div className="vision-icon">{icon}</div>

    <h4>{title}</h4>

    <p>{description}</p>

  </div>
);

// ================= MAIN COMPONENT =================

const AboutUs = () => {

  const { sarpanch } = aboutUsData;

  return (

    <div className="page about-us-page">

      <header className="page-header">

        <h1>{aboutUsData.title}</h1>

        <p>{aboutUsData.intro}</p>

      </header>

      <main>

        {/* Vision */}

        <section className="section">

          <h2>{aboutUsData.visionTitle}</h2>

          <div className="vision-cards-container">

            {aboutUsData.vision.map((item, index) => (

              <VisionItem key={index} {...item} />

            ))}

          </div>

        </section>

        {/* Services */}

        <section className="section">

          <h2>{aboutUsData.servicesTitle}</h2>

          <ul>

            {aboutUsData.services.map((item, i) => (

              <li key={i}>{item}</li>

            ))}

          </ul>

        </section>

        {/* Gram Panchayat Info */}

        <section className="section bg-light">

          <h2>{aboutUsData.gramPanchayatInfo.title}</h2>

          <div className="gav-info-grid">

            {aboutUsData.gramPanchayatInfo.details.map((item, i) => (

              <div key={i} className="gav-info-card">

                {item}

              </div>

            ))}

          </div>

        </section>

        {/* Population */}

        <section className="section">

          <h2>{aboutUsData.population2011.title}</h2>

          <div className="gav-info-grid">

            {aboutUsData.population2011.villages.map((v, i) => (

              <div key={i} className="gav-info-card">

                <h3>{v.name}</h3>

                <p>कुटुंब: {v.kutumb}</p>

                <p>स्त्री: {v.female}</p>

                <p>पुरुष: {v.male}</p>

                <p>एकूण: {v.total}</p>

              </div>

            ))}

            <div className="gav-info-card">

              <h3>एकूण</h3>

              <p>कुटुंब: {aboutUsData.population2011.total.kutumb}</p>

              <p>स्त्री: {aboutUsData.population2011.total.female}</p>

              <p>पुरुष: {aboutUsData.population2011.total.male}</p>

              <p>एकूण: {aboutUsData.population2011.total.total}</p>

            </div>

          </div>

        </section>

        {/* Education */}

        <section className="section bg-light">

          <h2>{aboutUsData.education.title}</h2>

          <ul>

            {aboutUsData.education.content.map((item, i) => (

              <li key={i}>{item}</li>

            ))}

          </ul>

        </section>

        {/* Participation */}

        <section className="section">

          <h2>{aboutUsData.participation.heading}</h2>

          <p>{aboutUsData.participation.content}</p>

        </section>

        {/* Sarpanch */}

        <section className="section">

          <h2>सरपंच : {sarpanch.name}</h2>

          <p>{sarpanch.slogan}</p>

        </section>

      </main>

      <footer className="page-footer">

        <p>{sarpanch.closing}</p>

      </footer>

    </div>

  );
};

export default AboutUs;
